var paragraph_default = {
  "fontElementMap": "B-XL-",
  "elementSpacing": "FMjBj",
  "text": "-XFiF FMjBj",
  "child": "TCUah"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
